import numeral from "numeral";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { MONTHS } from "../../constants";
import { anggaran, neraca } from "../../utils/financeFormula";
import { dateIndo } from "../../utils/helper";

const DetailNeraca = () => {
  const location = useLocation();
  const history = useHistory();
  const d = localStorage.getItem(location.pathname);
  const data = d ? JSON.parse(d) : null;
  if (data === null) history.push("/approval");

  const parseStatus = (s) => {
    const status = [
      {},
      { className: "badge badge-warning", text: "Pending" },
      { className: "badge badge-success", text: "Approved" },
      { className: "badge badge-danger", text: "Rejected" },
    ];
    return <span className={status[s].className}>{status[s].text}</span>;
  };

  const tables1 = [
    { label: "Created By", value: data?.createdBy?.name ?? "-", type: "text" },
    { label: "Created At", value: data?.createdAt ? dateIndo(data?.createdAt) : "-", type: "text" },
    { label: "Updated By", value: data?.updatedBy?.name ?? "-", type: "text" },
    { label: "Updated At", value: data?.updatedAt ? dateIndo(data?.updatedAt) : "-", type: "text" },
    { label: "Approved By", value: data?.approvedBy?.name ?? "-", type: "text" },
    { label: "Approved At", value: data?.approvedAt ? dateIndo(data?.approvedAt) : "-", type: "text" },
    { label: "Rejected By", value: data?.rejectedBy?.name ?? "-", type: "text" },
    { label: "Rejected At", value: data?.rejectedAt ? dateIndo(data?.rejectedAt) : "-", type: "text" },
    { label: "Status", value: parseStatus(data.status) },
  ];

  const tables2 = [
    { label: "Kas", value: data.kas, type: "numeral" },
    { label: "Piutang", value: data.piutang, type: "numeral" },
    { label: "Persediaan", value: data.persediaan, type: "numeral" },
    { label: "Lainnya", value: data.asetLancarLainnya, type: "numeral" },
    { label: <b>Total Current Asset</b>, value: neraca.currentAsset(data), type: "numeral" },
    { label: "Account Payable", value: data.accountPayable, type: "numeral" },
    { label: "Hutang Jangka Pendek", value: data.hutangJangkaPendek, type: "numeral" },
    { label: "Hutang Jangka Panjang", value: data.hutangJangkaPanjang, type: "numeral" },
    { label: <b>Total Liabilitas</b>, value: neraca.liabilitas(data), type: "numeral" },
    { label: "Laba Ditahan", value: data.labaDitahan, type: "numeral" },
    { label: "Modal Disetor", value: data.modalDisetor, type: "numeral" },
    { label: "Lainnya", value: data.ekuitasLain, type: "numeral" },
    { label: <b>Total Ekuitas</b>, value: neraca.ekuitas(data), type: "numeral" },
    { label: "Catatan", value: data?.notes ?? "-", type: "text" },
  ];

  const tables3 = [
    { label: " Kas dan Setara Kas ",value: data.kas,type: "numeral" },
    { label: " Investasi / Surat Berharga Jangka Pendek ",value: data.investasiJangkaPendek,type: "numeral" },
    { label: " Piutang Usaha"},
    { label: " Pihak Berelasi ",value: data.puPihakBerelasi,type: "numeral" },
    { label: " Pihak Ketiga ",value: data.puPihakKetiga,type: "numeral" },
    { label: " Piutang Lain-lain "},
    { label: " Pihak Berelasi ",value: data.plPihakBerelasi,type: "numeral" },
    { label: " Pihak Ketiga ",value: data.plPihakKetiga,type: "numeral" },
    { label: " Persediaan ",value: data.persediaan,type: "numeral" },
    { label: " Uang Muka Operasional ",value: data.uangMukaProyek,type: "numeral" },
    { label: " Uang Muka Proyek ",value: data.uangMukaOperasional,type: "numeral" },
    { label: " Pendapatan yang Masih Harus Diterima ",value: data.pendapatanHarusDiterima,type: "numeral" },
    { label: " Biaya Dibayar Dimuka ",value: data.biayaDibayarDimuka,type: "numeral" },
    { label: " Pajak Dibayar Dimuka ",value: data.pajakDibayarDimuka,type: "numeral" },
    { label: " Aset Jaminan ",value: data.asetJaminan,type: "numeral" },
    { label: " Bagian Piutang Jangka Panjang yang Akan Jatuh Tempo ",value: data.pjpJatuhTempo,type: "numeral" },
    { label: " Aset Lancar Lainnya ",value: data.asetLancarLainnya,type: "numeral" },
    { label: <b> Jumlah Aset Lancar </b>,value: neraca.currentAsset(data),type: "numeral" },
    { label: " Aset Tetap - Bersih ",value: data.asetTetapBersih,type: "numeral" },
    { label: " Aset Tak Berwujud - Bersih ",value: data.asetTakBerwujud,type: "numeral" },
    { label: " Aset Hak Guna ",value: data.asetHakGuna,type: "numeral" },
    { label: " Aset Tanah dalam Pengembangan ",value: data.asetTanahPengembangan,type: "numeral" },
    { label: " Aset Dalam Penyelesaian ",value: data.asetDalamPenyelesaian,type: "numeral" },
    { label: " Piutang Jangka Panjang "},
    { label: " Pihak Berelasi ",value: data.pjpPihakBerelasi,type: "numeral" },
    { label: " Pihak Ketiga ",value: data.pjpPihakKetiga,type: "numeral" },
    { label: " Uang Muka Pembelian Aset Tetap ",value: data.umpAsetTetap,type: "numeral" },
    { label: " Investasi Jangka Panjang ",value: data.investasiJangkaPanjang,type: "numeral" },
    { label: " Investasi pada Entitas Asosiasi ",value: data.investasiEntitasAsosiasi,type: "numeral" },
    { label: " Persediaan Real Estate ",value: data.persediaanRealEstate,type: "numeral" },
    { label: " Properti Investasi - Bersih ",value: data.propertiInvestasiBersih,type: "numeral" },
    { label: " Aset Pajak Tangguhan ",value: data.asetPajakTangguhan,type: "numeral" },
    { label: " Taksiran Tagihan Restitusi Pajak ",value: data.taksiranRestitusiPajak,type: "numeral" },
    { label: " Aset Pengampunan Pajak ",value: data.asetPengampunanPajak,type: "numeral" },
    { label: " Cadangan Imbalan Pasca Kerja ",value: data.cadanganImbalanKerja,type: "numeral" },
    { label: " Aset Tidak Lancar Lainnya ",value: data.asetTidaklancarLainnya,type: "numeral" },
    { label: <b>Jumlah Aset Tidak Lancar</b>,value: neraca.fixedAsset(data),type: "numeral" },
    { label: <b> JUMLAH ASET</b>,value: neraca.jumlahAset(data),type: "numeral" },
    { label: " Utang Bank Jangka Pendek ",value: data.utangBankPendek,type: "numeral" },
    { label: " Utang Usaha "},
    { label: " Pihak Berelasi ",value: data.uuPihakBerelasi,type: "numeral" },
    { label: " Pihak Ketiga ",value: data.uuPihakKetiga,type: "numeral" },
    { label: " Utang Lain-lain "},
    { label: " Pihak Berelasi ",value: data.ulPihakBerelasi,type: "numeral" },
    { label: " Pihak Ketiga ",value: data.ulPihakKetiga,type: "numeral" },
    { label: " Utang Retensi Jangka Pendek ",value: data.utangRetensiPendek,type: "numeral" },
    { label: " Utang Pajak  ",value: data.utangPajak,type: "numeral" },
    { label: " Pendapatan Diterima Dimuka Jangka Pendek ",value: data.pddPendek,type: "numeral" },
    { label: " Utang Dividen ",value: data.utangDeviden,type: "numeral" },
    { label: " Utang Sewa ",value: data.utangSewa,type: "numeral" },
    { label: " Biaya yang Masih Harus Dibayar Jangka Pendek ",value: data.biayaDibayarPendek,type: "numeral" },
    { label: " Bagian Utang Bank yang Akan Jatuh Tempo ",value: data.bubJatuhTempo,type: "numeral" },
    { label: " Liabilitas Jangka Pendek Lainnya ",value: data.liabilitasPendekLainnya,type: "numeral" },
    { label: <b> Jumlah Liabilitas Jangka Pendek</b>,value: neraca.liabilitasJangkaPendek(data),type: "numeral" },
    { label: " Utang Bank Jangka Panjang ",value: data.utangBankPanjang,type: "numeral" },
    { label: " Utang Lain-lain "},
    { label: " Pihak Berelasi ",value: data.ulpPihakBerelasi,type: "numeral" },
    { label: " Pihak Ketiga ",value: data.ulpPihakKetiga,type: "numeral" },
    { label: " Pendapatan Diterima Dimuka Jangka Panjang ",value: data.pddPanjang,type: "numeral" },
    { label: " Pajak Tangguhan ",value: data.pajakTangguhanNeraca,type: "numeral" },
    { label: " Utang Retensi Jangka Panjang ",value: data.utangRetensiPanjang,type: "numeral" },
    { label: " Biaya yang Masih Harus Dibayar Jangka Panjang ",value: data.biayaDibayarPanjang,type: "numeral" },
    { label: " Utang Pembiayaan Jangka Panjang ",value: data.utangPembiayaanPanjang,type: "numeral" },
    { label: " Liabilitas Imbalan Pasca Kerja ",value: data.liabilitasImbalanKerja,type: "numeral" },
    { label: " Titipan Dana Pelepasan Aset ",value: data.titipanPelepasanAset,type: "numeral" },
    { label: " Utang Lain-lain Dalam Penyelesaian ",value: data.utangLainPenyelesaian,type: "numeral" },
    { label: " Liabilitas Jangka Panjang Lainnya ",value: data.liabilitasPanjangLainnya,type: "numeral" },
    { label: <b> Jumlah Liabilitas Jangka Panjang</b>,value: neraca.liabilitasJangkaPanjang(data),type: "numeral" },
    { label: <b> JUMLAH LIABILITAS</b>,value: neraca.liabilitas(data),type: "numeral" },
    { label: " Modal Saham ",value: data.modalSaham,type: "numeral" },
    { label: " Tambahan Modal Disetor ",value: data.tambahanModalDisetor,type: "numeral" },
    { label: " Cadangan Modal ",value: data.cadanganModal,type: "numeral" },
    { label: " Saldo Laba (Rugi) "},
    { label: " Telah Ditentukan Penggunaannya ",value: data.telahDitentukanPenggunaan,type: "numeral" },
    { label: " Belum Ditentukan Penggunaannya ",value: data.belumDitentukanPenggunaan,type: "numeral" },
    { label: " Penghasilan Komprehensif Lain ",value: data.penghasilanKomperhensifLain,type: "numeral" },
    { label: " Dividen ",value: data.deviden,type: "numeral" },
    { label: " Komponen Ekuitas Lain ",value: data.komponenEkuitasLain,type: "numeral" },
    { label: " Kepentingan Non Pengendali ",value: data.kepentinganNonPengendali,type: "numeral" },
    { label: <b>JUMLAH EKUITAS </b>,value: neraca.ekuitas(data),type: "numeral" },
    { label: <b> JUMLAH LIABILITAS DAN EKUITAS </b>,value: neraca.jumlahLiabilitasEkuitas(data),type: "numeral" },
    { label: "Catatan", value: data?.notes ?? "-", type: "text" },
   
  ];

  return (
    <>
      <div className="card border-0 rounded-0">
        <div className="container py-4">
          <div className="row px-4">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mr-auto my-auto">
                Detail Neraca - {MONTHS[data.month * 1 - 1]} {data.year}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-3">
        <div className="card container shadow-sm border-0 p-3">
          <div className="row">
            <div className="col-6">
              <table className="table table-striped">
                <tbody>
                  {tables3.map((table, i) => (
                    <tr key={i}>
                      <td width={300}>{table.label}</td>
                      <td>:&ensp; {table.type === "numeral" ? `Rp. ${numeral(table.value).format(0, 0)}` : table.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="col-6">
              <table className="table table-striped">
                <tbody>
                  {tables1.map((table, i) => (
                    <tr key={i}>
                      <td width={150}>{table.label}</td>
                      <td>:&ensp; {table.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="btn btn-secondary" onClick={() => window.history.back()}>
                Kembali
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailNeraca;
